import React from "react"
import { Grid, Link } from "@mui/material"
import { styled } from "@mui/material/styles"
import { FormattedMessage, useIntl } from "react-intl"

import FooterText from "atoms/text/FooterText"
import TextCopyright from "atoms/text/TextCopyright"
import { getLocaleJaOrEnInitialUpper } from "locale.js"

const Container = styled(Grid)({
  textAlign: "left",
  backgroundColor: "#727272",
  paddingTop: "18px",
  paddingBottom: "18px",
})

const Space = styled(Grid)({
  paddingTop: "6px",
  paddingBottom: "6px",
  paddingRight: "20px",
  paddingLeft: "20px",
})

const Copyright = styled(Grid)({
  paddingRight: "20px",
  paddingLeft: "20px",
  paddingTop: "22px",
  paddingBottom: "6px",
})

const LinkLeftAdjust = () => {
  const intl = useIntl()
  const privacyPolicyLink = intl.formatMessage({
    id: "Footer.PrivacyPolicyLink",
  })
  const dataGaFAQ = "footerToFAQ" + getLocaleJaOrEnInitialUpper()
  const dataGaPersonalDataCharter =
    "footerToPersonalDataCharter" + getLocaleJaOrEnInitialUpper()
  const dataGaPrivacyPolicy =
    "footerToPrivacyPolicy" + getLocaleJaOrEnInitialUpper()
  const dataGaProvisionToThirdParty =
    "footerToProvisionToThirdParty" + getLocaleJaOrEnInitialUpper()

  return (
    <Container container>
      <Space item xs={12} id="personalDataCharter">
        <Link
          href="https://www.docomo.ne.jp/utility/personal_data/other_info/"
          target="_blank"
          rel="noopener noreferrer"
          data-ga={dataGaPersonalDataCharter}
          underline="hover"
        >
          <FooterText>
            <FormattedMessage id="Footer.PersonalDataCharter" />
          </FooterText>
        </Link>
      </Space>

      <Space item xs={12} id="PrivacyPolicy">
        <Link
          href={privacyPolicyLink}
          target="_blank"
          rel="noopener noreferrer"
          data-ga={dataGaPrivacyPolicy}
          underline="hover"
        >
          <FooterText>
            <FormattedMessage id="Footer.PrivacyPolicy" />
          </FooterText>
        </Link>
      </Space>

      <Space item xs={12} id="ProvisionToThirdParty">
        <Link
          href="https://id-biz.smt.docomo.ne.jp/src/utility/providing_destinations.html"
          target="_blank"
          rel="noopener noreferrer"
          data-ga={dataGaProvisionToThirdParty}
          underline="hover"
        >
          <FooterText>
            <FormattedMessage id="Footer.ProvisionToThirdParty" />
          </FooterText>
        </Link>
      </Space>

      <Space item xs={12} id="FAQ">
        <Link
          href="https://www.docomo.ne.jp/faq/"
          target="_blank"
          rel="noopener noreferrer"
          data-ga={dataGaFAQ}
          underline="hover"
        >
          <FooterText>
            <FormattedMessage id="Footer.FAQ" />
          </FooterText>
        </Link>
      </Space>
      <Copyright item xs={12}>
        <TextCopyright />
      </Copyright>
    </Container>
  )
}

export default LinkLeftAdjust
